import { render, staticRenderFns } from "./PerformanceAnalysisPage.vue?vue&type=template&id=1b9580b8&"
import script from "./PerformanceAnalysisPage.vue?vue&type=script&lang=js&"
export * from "./PerformanceAnalysisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports